import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Status } from '../../../common/constants';
import { regenerateCapEndpointTokenUrl } from '../../../config';
import api from '../../../api';
import { RootState } from '../../../store';

interface IRegenerateCapEndpointState {
  status: string;
  error: string | null;
}

const initialState: IRegenerateCapEndpointState = {
  status: Status.IDLE,
  error: null,
};

export const regenerateCapEndpointToken: any = createAsyncThunk(
  'regenerateCapEndpointToken',
  async (endpointId: string, { rejectWithValue }) => {
    try {
      const response = await api.post(regenerateCapEndpointTokenUrl, { endpointId });
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const regenerateCapEndpointTokenSlice = createSlice({
  name: 'regenerateCapEndpointToken',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(regenerateCapEndpointToken.pending, (state) => {
        state.status = Status.PENDING;
        state.error = null;
      })
      .addCase(regenerateCapEndpointToken.fulfilled, (state) => {
        state.status = Status.SUCCESS;
      })
      .addCase(regenerateCapEndpointToken.rejected, (state, action) => {
        const errorPayload = action.payload as { response?: { data?: { message?: string } } };
        state.status = Status.FAILED;
        state.error = errorPayload?.response?.data?.message || action.error.message || 'Unknown error';
      });
  },
});

export const selector = (state: RootState) => state.regenerateCapEndpointToken;
export default regenerateCapEndpointTokenSlice.reducer;
